import { Heading, Paragraph } from '@expressable/syntax-ds';
import { PlaceholderImg } from 'components/LoadingImage/LoadingImage';

type TypeOutcomeTileProps = {
  heading: string;
  description: string;
  icon: string;
};

export const OutcomeTile = ({ heading, description, icon }: TypeOutcomeTileProps) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <PlaceholderImg src={icon} className="max-w-[160px]" />
      <Heading level="h3" className="text-center mt-20 max-w-sm">
        {heading}
      </Heading>
      <Paragraph className="text-center max-w-sm">{description}</Paragraph>
    </div>
  );
};
